export default {
  bold: 'Negrito',
  italic: 'Itálico',
  underline: 'Sublinhado',
  insertUnorderedList: 'Lista com marcadores',
  insertOrderedList: 'Lista numerada'
}
